export default __webpack_public_path__ + "static/media/full-logo-secondary.2807a94c.svg";